<template>
  <div class="reviewing-guide-content">
    <div class="guide">
      <div class="text">
        <div class="title">恭喜您获得100%提额特权，可再借<span class="amount">{{amount || 0}}</span>元 ></div>
        <div class="channel-count-down" v-if="countdownVisible">
          <div>距离通道关闭&nbsp;</div>
          <van-count-down
            :time="countDownSeconds"
            @finish="countDownFinished"
          />
        </div>
      </div>
      <img src="../../image/img_upcard_guide_privilege.png">
    </div>
    <div class="actions">
      <nd-button @click="buyAction" data-sensors-click>开通并使用{{amount}}元额度</nd-button>
      <div class="protocol" @click="protocolAction">开通即同意<span class="detail">《会员用户协议》</span></div>
    </div>
  </div>
</template>

<script>
import CountDownTool from '@/assets/CountDownTool.js'
export default {
  props: {
    result: {
      type: Object,
      default: () => ({})
    }
  },
  created () {
    this.countDownSeconds = CountDownTool.setCountDownInfo(CountDownTool.Keys.reviewingGuideUpCountDownTimeStamp, 15 * 60 * 1000)
  },
  data () {
    return {
      countDownSeconds: 0
    }
  },
  computed: {
    amount () {
      return this.result.upLimit
    },
    countdownVisible () {
      return this.countDownSeconds > 0
    }
  },
  methods: {
    buyAction () {
      this.$emit('onBuy')
    },
    protocolAction () {
      this.$router.push('/protocol/vip-wh')
    },
    countDownFinished () {
      this.countDownSeconds = 0
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.reviewing-guide-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  .guide {
    padding: 31px 10px 10px 10px;
    background: #F7F1EB;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    .text {
      padding: 0 20px 31px 20px;
      .title {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
        .amount {
          color: #FF4633;
        }
      }
      .channel-count-down {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 33px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .van-count-down {
          font-size: 24px;
          font-weight: 400;
          color: #FF4633;
          line-height: 33px;
        }
      }
    }
    img {
      width: 100%;
    }
  }
  .actions {
    margin-top: 30px;
    .protocol {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 33px;
      text-align: center;
      margin-top: 20px;
      .detail {
        color: #8EB2D8;
      }
    }
  }
}
</style>